import { useQuery } from "@tanstack/react-query";

import type { UseQueryOptions } from "shared/types";

import { axiosNodeInstance } from "shared/utils/axiosInstance";

import { transactionKeys } from "./queryKeys";

export type TotalTransactionQueryResponse = {
  sessions: number;
  volume: number;
};

type Params = { endDate: string; startDate: string };

export const useTotalTransactionByPeriodQuery = (
  params: Params,
  options: UseQueryOptions<Record<string, TotalTransactionQueryResponse>> = {},
) => {
  return useQuery({
    queryFn: async ({ signal }) => {
      const { data } = await axiosNodeInstance.get<Record<string, TotalTransactionQueryResponse>>(
        "/transactions/volume-by-period",
        {
          params,
          signal,
          timeout: 30000,
        },
      );
      return data;
    },
    queryKey: transactionKeys.totalTransactionsByPeriod(params),
    ...options,
  });
};
